import type { RpcMetricsToggleViewProps } from "@/domains/diagnostics/types"
import { Card } from "@/components/card"
import { Switch } from "@/components/switch"

export const RpcMetricsToggleView = ({ enabled, onToggle }: RpcMetricsToggleViewProps) => {
  return (
    <Card.Container className="border-p400-light bg-p400">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-t100">RPC Metrics Collection</h3>
          <p className="mt-1 text-sm text-t200">
            Enable detailed RPC metrics tracking for debugging. This is session-only and not persisted.
          </p>
        </div>
        <Switch checked={enabled} onCheckedChange={onToggle} />
      </div>
    </Card.Container>
  )
}
